import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const fmtNL = (d) => new Date(d).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' });

export default function InzetAanvragen({ magBeheer }) {
  const [aanvragen, setAanvragen] = useState([]);
  const [bezig, setBezig] = useState(null);
  const [open, setOpen] = useState(null);
  const [bijlagen, setBijlagen] = useState({});

  const laad = useCallback(() => {
    api.get('/inzetmiddelen/aanvragen')
      .then(r => setAanvragen(r.data.aanvragen || []))
      .catch(() => {});
  }, []);
  useEffect(() => { laad(); }, [laad]);

  const toggleDetail = (a) => {
    const nieuw = open === a.id ? null : a.id;
    setOpen(nieuw);
    if (nieuw && a.bijlagen_count > 0 && !bijlagen[a.id]) {
      api.get('/inzetmiddelen/aanvragen/' + a.id + '/bijlagen')
        .then(r => setBijlagen(b => ({ ...b, [a.id]: r.data.bijlagen || [] })))
        .catch(() => {});
    }
  };

  const downloadBijlage = (aId, b) => {
    api.get('/inzetmiddelen/aanvragen/' + aId + '/bijlagen/' + b.id + '/download', { responseType: 'blob' })
      .then(r => {
        const url = URL.createObjectURL(r.data);
        const a = document.createElement('a');
        a.href = url; a.target = '_blank';
        if (!(b.mimetype || '').startsWith('image/') && b.mimetype !== 'application/pdf') a.download = b.originele_naam;
        a.click();
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      })
      .catch(() => alert('Download mislukt'));
  };

  const goedkeuren = (a) => {
    if (!window.confirm('Aanvraag #' + a.id + ' goedkeuren?\nEr worden direct Brengen- en Ophalen-orders ingepland en de aanvrager krijgt een mail.')) return;
    setBezig(a.id);
    api.put('/inzetmiddelen/aanvragen/' + a.id + '/goedkeuren')
      .then(() => { setBezig(null); laad(); })
      .catch(e => { setBezig(null); alert(e.response?.data?.message || 'Goedkeuren mislukt'); });
  };
  const afwijzen = (a) => {
    const reden = window.prompt('Reden van afwijzing (wordt naar de aanvrager gemaild):');
    if (!reden) return;
    setBezig(a.id);
    api.put('/inzetmiddelen/aanvragen/' + a.id + '/afwijzen', { reden })
      .then(() => { setBezig(null); laad(); })
      .catch(e => { setBezig(null); alert(e.response?.data?.message || 'Afwijzen mislukt'); });
  };

  if (aanvragen.length === 0) return null;

  return (
    <div style={{ background: '#fff', border: '1px solid #fde68a', borderLeft: '4px solid #f59e0b', borderRadius: 10, padding: '14px 16px', margin: '14px 0' }}>
      <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 10 }}>
        📥 Openstaande aanvragen <span style={{ background: '#fef3c7', color: '#92400e', borderRadius: 999, padding: '2px 10px', fontSize: 12 }}>{aanvragen.length}</span>
      </div>
      {aanvragen.map(a => (
        <div key={a.id} style={{ borderTop: '1px solid #f3f4f6', padding: '10px 0' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 14, fontWeight: 600 }}>
                #{a.id} · {a.aantal}x {a.type_naam}
                {a.partij_naam && <span style={{ marginLeft: 8, fontSize: 11, fontWeight: 700, color: '#2563eb', border: '1px solid #bfdbfe', borderRadius: 999, padding: '1px 8px' }}>{a.partij_naam}</span>}
                {a.bijlagen_count > 0 && <span style={{ marginLeft: 8, fontSize: 11, color: '#6b7280' }}>📎 {a.bijlagen_count}</span>}
              </div>
              <div style={{ fontSize: 13, color: '#6b7280' }}>
                {fmtNL(a.van_datum)} t/m {fmtNL(a.tot_datum)} · {a.locatie_adres || a.bestemming || '—'}
                {a.aanvrager_naam ? ' · ' + a.aanvrager_naam : ''}
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="inzet-btn-light" onClick={() => toggleDetail(a)}>{open === a.id ? 'Sluit' : 'Details'}</button>
              {magBeheer && <>
                <button className="btn-primary" disabled={bezig === a.id} onClick={() => goedkeuren(a)}>✓ Goedkeuren</button>
                <button className="inzet-btn-light" style={{ color: '#dc2626' }} disabled={bezig === a.id} onClick={() => afwijzen(a)}>✕ Afwijzen</button>
              </>}
            </div>
          </div>
          {open === a.id && (
            <div style={{ marginTop: 8, fontSize: 13, color: '#374151', background: '#f9fafb', borderRadius: 8, padding: '10px 12px' }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 6 }}>
                <div><b>Aanvrager:</b> {a.aanvrager_naam || '—'}</div>
                <div><b>E-mail:</b> {a.aanvrager_email || '—'}</div>
                <div><b>Telefoon:</b> {a.aanvrager_telefoon || '—'}</div>
                <div><b>Afdeling/Project:</b> {a.afdeling_project || '—'}</div>
                <div><b>Ordernummer:</b> {a.ordernummer || '—'}</div>
                <div><b>Meldingsnummer:</b> {a.meldingsnummer || '—'}</div>
                <div><b>Locatiebepaling:</b> {a.loc_tekening ? 'Tekening bijgevoegd' : a.loc_markeren ? 'Wordt gemarkeerd (aangespoten)' : '—'}</div>
                <div><b>Verklaring akkoord:</b> {a.verklaring_akkoord ? 'Ja' : 'Nee'}</div>
                <div style={{ gridColumn: '1 / -1' }}><b>Bijzonderheden:</b> {a.reden || '—'}</div>
              </div>
              {a.bijlagen_count > 0 && (
                <div style={{ marginTop: 8, borderTop: '1px solid #e5e7eb', paddingTop: 8 }}>
                  <b>Bijlagen:</b>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 4 }}>
                    {(bijlagen[a.id] || []).map(b => (
                      <button key={b.id} className="inzet-btn-light" onClick={() => downloadBijlage(a.id, b)}>
                        {(b.mimetype === 'application/pdf' ? '📄 ' : '🖼️ ') + b.originele_naam}
                      </button>
                    ))}
                    {!bijlagen[a.id] && <span style={{ color: '#6b7280' }}>laden…</span>}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
